import {bootstrapPhpIntegration} from "./bootstrap-php-integration";
import {waitUntil} from "../../common/utils/wait-until";

waitUntil(
    () => !!document.getElementById('react-header') && !!document.getElementById('react-footer'),
    () => bootstrapPhpIntegration(
        document.getElementById('react-header'),
        document.getElementById('react-footer'),
    )
);